"use client";

import { Button } from "@workspace/ui/components/button";
import type { ReactNode } from "react";

type AuthProviderButtonProps = {
  disabled?: boolean;
  icon?: ReactNode;
  label: string;
  loading?: boolean;
  onClick: () => void;
  showLastUsed?: boolean;
  variant?: "default" | "outline";
};

export function AuthProviderButton({
  disabled,
  icon,
  label,
  loading,
  onClick,
  showLastUsed = false,
  variant = "outline",
}: AuthProviderButtonProps) {
  return (
    <div className="relative w-full">
      <Button
        className="w-full"
        disabled={disabled || loading}
        onClick={onClick}
        type="button"
        variant={variant}
      >
        <span className="inline-flex items-center">
          {icon ? <span className="mr-2">{icon}</span> : null}
          <span>{label}</span>
        </span>
      </Button>
      {showLastUsed && !loading ? (
        <div className="-translate-y-1/2 pointer-events-none absolute top-1/2 right-3">
          <span className="text-[10px] text-muted-foreground">Last used</span>
        </div>
      ) : null}
    </div>
  );
}
